<template>
  <div class="rotateScreen touch">
    <img class="bgImg bgImgRatio" :src="this.bgCastleImg">
    <img class="rotate" v-show="this.isShowRotateDialog" v-if="this.language == 'TC'" src="~@/../src/assets/images/general/rotateTC.png">
    <img class="rotate" v-show="this.isShowRotateDialog" v-if="this.language == 'EN'" src="~@/../src/assets/images/general/rotateEN.png">
  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '../store'
import base64BgCastle from '@/assets/images/base64/bgCastle.js';

export default {
  name: 'rotateScreen',
  data () {
    return {
      language : i18n.locale,
      fontSize : store.state.fontSize,
      imgRotateScreen : './static/images/rotateScreen.png',
      bgCastleImg : base64BgCastle.data,
      isShowRotateDialog : false,
    }
  },
  created(){
      this.scheduleShow();
  },
  methods:{
    scheduleShow(){
      let self = this;
      setTimeout(function(){
        self.showDialog();
      }, 2000);
    },
    showDialog(){
      let self = this;
      this.isShowRotateDialog = true;
    },
  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkFontSize(){return store.state.fontSize},

  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
    checkFontSize(flag){this.fontSize = flag;},
  },
}
</script>

<style scoped>
  @media screen and (orientation:landscape) {

    .bgImg{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
    }

    @media (max-aspect-ratio: 1680 / 945){.bgImgRatio{min-width: 100%;max-height: 100%}}
    @media (min-aspect-ratio: 1680 / 945){.bgImgRatio{width: 100%; min-width: 100%;min-height: 100%}}



    .rotateScreen{
      position: fixed;
      top: 0%;
      left: 0%;
      width: 100vw;
      height: 100vh;
    }

    .rotate{
      position: absolute;
      width: 45vw;
      top: 18vh;
      left: 50%;
      transform: translate3d(-50%,0,0);
    }

  }

  @media screen and (orientation:portrait) {
    .rotateScreen{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rotateScreen.vue